/* Sticky add-to-cart bar behaviour:
   - shows the bar after the visitor scrolls past the main buy button
   - keeps its variant, price and availability synchronized with the PDP
*/
(function () {
  function init() {
    var bar = document.querySelector('.ct-sticky-atc');
    if (!bar) return;

    var mainSubmit = document.querySelector('.product-form__submit');
    var sentinel = mainSubmit || document.querySelector('.product__info-wrapper');

    function setVisibility(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window && sentinel) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var pastSentinel = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            setVisibility(pastSentinel);
          });
        },
        { threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      window.addEventListener('scroll', function () {
        setVisibility(window.scrollY > 700);
      });
    }

    var select = bar.querySelector('[data-sticky-variant-select]');
    var hiddenInput = bar.querySelector('[data-sticky-variant-input]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var variantTitleEl = bar.querySelector('[data-sticky-variant-title]');
    var button = bar.querySelector('.ct-sticky-atc__button');
    var buttonText = button && button.querySelector('span');
    var addLabel = bar.dataset.addLabel || 'Add to cart';
    var soldOutLabel = bar.dataset.soldOutLabel || 'Sold out';

    function syncOption(option, variant) {
      if (!option || !hiddenInput) return;

      hiddenInput.value = option.value;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl) {
        var priceHtml = option.dataset.price || '';
        if (option.dataset.compare) {
          priceHtml += ' <s>' + option.dataset.compare + '</s>';
        }
        priceEl.innerHTML = priceHtml;
      }

      if (variantTitleEl) {
        variantTitleEl.textContent = (variant && variant.title) || option.textContent.replace(/\s+—\s+.+$/, '').trim();
      }

      var unavailable = variant ? !variant.available : option.disabled;
      if (button) button.disabled = unavailable;
      if (buttonText) buttonText.textContent = unavailable ? soldOutLabel : addLabel;
    }

    if (select && hiddenInput) {
      select.addEventListener('change', function () {
        syncOption(select.options[select.selectedIndex]);
      });
    }

    if (
      select &&
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.variantChange
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || String(data.sectionId) !== String(bar.dataset.sectionId)) return;

        var variant = data.variant;
        if (!variant) {
          if (button) button.disabled = true;
          if (buttonText) buttonText.textContent = soldOutLabel;
          return;
        }

        select.value = String(variant.id);
        syncOption(select.options[select.selectedIndex], variant);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
